import { Handle, Position } from '@xyflow/react';
import { CButton } from '@coreui/react';
import { X } from 'lucide-react'; // icona per la X di eliminazione card
import { useCallback } from 'react';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
const CardSuggestionNode = ({ id, data }) => {

  const navigate = useNavigate();
  const handleDeleteClick = useCallback((e) => {
    e.stopPropagation();
    if (data.onDelete) data.onDelete(id);
  }, [data, id]);


  return (
    <div style={{
      padding: '10px',
      border: '3px solid var(--card-suggestion-color)',
      boxShadow: '0 0 30px var(--card-suggestion-color)',
      borderRadius: '15px',
      backgroundColor: 'var(--background-card-color)',
      textAlign: 'center',
    }}>
      {/* pulsante X per eliminare */}
      <button
        onClick={handleDeleteClick}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
           color: 'var(--card-suggestion-color)',
          cursor: 'pointer',
        }}
        title="Elimina nodo"
      >
        <X size={13} />
      </button>
      <p style={{color: 'white', fontWeight: '700', borderBottom: '1px solid var(--card-suggestion-color)'}}>{data.node.title}</p>

      <CButton
        style={{
          borderRadius: '15px',
          backgroundColor: 'var(--card-suggestion-color)'
        }}
        className='text-uppercase text-white'
        size="sm"
        onClick={() => navigate(`${data.node.id}/edit_cardSuggestion`)}
      >
        {t('button.edit')}
      </CButton>

      {/* Handles per connettere i nodi */}
      <Handle type="target" position={Position.Top} />

    </div>
  );
};

export default CardSuggestionNode;




